import { MyInput } from '@/components/common/Form'
import Content from '@/components/specific/Content'
import { useDocumentTitle } from '@/utils/hooks/useDocumentTitle'
import { useGetDetailPelanggan } from '@/utils/hooks/useFetchWrapper'
import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import numeral from 'numeral';

import global from '../../../utils/helpers/global';
import { _getDetailPelanggan } from '../../../utils/apis/InfoPelanggan';

function Tagihan() {
    const { search } = useLocation();
    const qparams = new URLSearchParams(search);

    var history = qparams.get('history') ?? null;
    if (history === 'null') history = null;

    var last_page = qparams.get('last_page') ?? null;
    if (last_page === 'null') last_page = null;

    const contentHeader = {
        title: 'Info Tagihan'
    }

    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [pelanggan, setPelanggan] = useState(null)
    const [summary, setSummary] = useState({
        amount: 0,
        month: 0
    });
    const [dataTagihan, setDataTagihan] = useState([])

    const [firstInit, setFirstInit] = useState(true);
    const [page, setPage] = useState(last_page ?? 1);
    const [totalPage, setTotalPage] = useState(1);

    const [payload, setPayload] = useState({
        kode_pelanggan: history,
        page: page,
        limit: 10,
        // order_by_field: 'period',
        // order_by_type: 'desc'
    });

    const getData = async (_page = null) => {
        try {
            setIsLoading(true);
            setPelanggan(null);

            let _payload = payload;
            if (_page) _payload.page = _page;
            const response = await _getDetailPelanggan(_payload);
            const data = response?.data?.data ?? null;

            if (data?.pelanggan) {
                // appending summary
                const _summary = data.list_tagihan?.summary ?? null;
                if (_summary) {
                    setSummary({
                        amount: _summary?.amount ?? 0,
                        month: _summary?.month ?? 0
                    });
                }

                // preparing data tagihan
                const list_tagihan = data.list_tagihan?.data ?? [];
                let data_tagihan = [];

                // private variable
                const _fieldsInDetail = ['id', 'periode_tahun', 'periode_bulan', 'status', 'total_tagihan'];

                // perform to filling up the data
                for (let i = 0; i < list_tagihan.length; i++) {
                    let each_data = {
                        id: null,
                        year: null,
                        month: null,
                        status: null,
                        total_tagihan: 0
                    }

                    // looking for detail
                    for (let j = 0; j < list_tagihan[i].length; j++) {
                        if (_fieldsInDetail.includes(list_tagihan[i][j]?.key?.toLowerCase())) {
                            let f = list_tagihan[i][j].key.toLowerCase();
                            if (f === 'periode_bulan') f = 'month';
                            if (f === 'periode_tahun') f = 'year';
                            each_data[f] = list_tagihan[i][j]?.value ?? null;
                        }
                    }

                    // prepare to joining
                    // grouping by year for each detail
                    if (each_data.id !== null && each_data.year !== null) {
                        each_data.month = global.convert_month(each_data.month);
                        const x = data_tagihan.findIndex(x => x?.year === each_data.year);
                        if (x >= 0) {
                            data_tagihan[x].details.push(each_data);
                        } else {
                            data_tagihan.push({
                                year: parseInt(each_data.year),
                                details: [each_data]
                            });
                        }
                    }
                }

                // updating state
                setPelanggan(data?.pelanggan ?? null);
                setFirstInit(false);
                setDataTagihan(data_tagihan);
                setTotalPage(data?.list_tagihan?.total_page ?? 1);
            } else {
                setIsError(true);
            }
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
            setIsError(true);
        }
    }

    useEffect(() => {
        setPage(last_page ?? 1);
        async function __init() {
            setIsLoading(true);
            setFirstInit(true);
            await getData(last_page ?? 1);
        }
        if (history) __init(); // first init if there is default data
    }, []);

    return (
        <Content>
            {/* Header Section */}
            <div className={`text-center ${pelanggan ? 'mb-2' : 'my-12'}`}>
                <h1 className="text-3xl md:text-4xl font-semibold text-gray-800 mb-2">
                    Info Tagihan
                </h1>
                <p className="text-gray-600">Cek informasi tagihan pelanggan Anda</p>
            </div>

            {/* Search Section */}
            <div className="w-full max-w-5xl mx-auto mb-8">
                <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
                    <div className="flex gap-3 flex-col sm:flex-row" data-theme="mytheme">
                        <div className="flex w-full">
                            <MyInput
                                type="text"
                                placeholder="Masukkan Nomor Sambung"
                                defaultValue={payload.kode_pelanggan}
                                onChange={(e) => setPayload({ ...payload, kode_pelanggan: e.target.value })}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        getData();
                                        setFirstInit(true);
                                    }
                                }}
                            />
                        </div>
                        <button
                            className="btn bg-primary text-white hover:bg-primary border-0 px-8 sm:w-auto w-full"
                            onClick={() => {
                                getData();
                                setFirstInit(true);
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            Cari
                        </button>
                    </div>
                </div>
            </div>

            {/* Data Pelanggan */}
            {
                (pelanggan) &&
                (
                    <div className="w-full max-w-5xl mx-auto mb-6">
                        {/* Summary Cards */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                            {/* Total Tunggakan Card */}
                            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-lg shadow-md p-6 border border-red-200">
                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="text-red-600 text-sm font-medium mb-1">Total Tunggakan</p>
                                        <h3 className="text-2xl md:text-3xl font-bold text-red-700">
                                            Rp. {numeral(summary.amount).format('0,0')}
                                        </h3>
                                    </div>
                                    <div className="bg-red-200 p-3 rounded-full">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            {/* Total Bulan Card */}
                            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg shadow-md p-6 border border-blue-200">
                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="text-blue-600 text-sm font-medium mb-1">Jumlah Bulan Tunggakan</p>
                                        <h3 className="text-2xl md:text-3xl font-bold text-blue-700">
                                            {numeral(summary.month).format('0,0')} Bulan
                                        </h3>
                                    </div>
                                    <div className="bg-blue-200 p-3 rounded-full">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Detail Data Pelanggan */}
                        <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
                            <div className="bg-[#095393] px-6 py-4">
                                <span className="text-lg font-semibold text-white flex items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                    </svg>
                                    Data Pelanggan
                                </span>
                            </div>
                            <div className="p-6">
                                <div className="space-y-3">
                                    <div className="flex flex-col sm:flex-row sm:items-center py-3 border-b border-gray-200">
                                        <div className="sm:w-2/5 mb-1 sm:mb-0">
                                            <span className="text-gray-600 font-medium text-sm">Nomor Sambung</span>
                                        </div>
                                        <div className="sm:w-3/5">
                                            <span className="text-gray-900 font-semibold">{pelanggan.kode_pelanggan}</span>
                                        </div>
                                    </div>
                                    <div className="flex flex-col sm:flex-row sm:items-center py-3 border-b border-gray-200">
                                        <div className="sm:w-2/5 mb-1 sm:mb-0">
                                            <span className="text-gray-600 font-medium text-sm">Nama Pelanggan</span>
                                        </div>
                                        <div className="sm:w-3/5">
                                            <span className="text-gray-900">{pelanggan.nama}</span>
                                        </div>
                                    </div>
                                    <div className="flex flex-col sm:flex-row sm:items-start py-3 border-b border-gray-200">
                                        <div className="sm:w-2/5 mb-1 sm:mb-0">
                                            <span className="text-gray-600 font-medium text-sm">Alamat</span>
                                        </div>
                                        <div className="sm:w-3/5">
                                            <span className="text-gray-900">{pelanggan.alamat}</span>
                                        </div>
                                    </div>
                                    <div className="flex flex-col sm:flex-row sm:items-center py-3">
                                        <div className="sm:w-2/5 mb-1 sm:mb-0">
                                            <span className="text-gray-600 font-medium text-sm">Golongan</span>
                                        </div>
                                        <div className="sm:w-3/5">
                                            <span className="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                                                {pelanggan.golongan}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            {/* Periode Tahun */}
            {
                (pelanggan) &&
                (
                    <div className="w-full max-w-5xl mx-auto mb-6">
                        <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
                            <div className="bg-[#095393] px-6 py-4">
                                <span className="text-lg font-semibold text-white flex items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                    </svg>
                                    Riwayat Tagihan per Periode
                                </span>
                            </div>
                            <div className="p-4 sm:p-6">
                                {
                                    dataTagihan.map((data, idx) => (
                                        <div key={idx} className="collapse collapse-arrow bg-gray-50 border border-gray-200 rounded-lg mb-3 shadow-sm hover:shadow-md transition-shadow">
                                            <input type="radio" name="my-accordion-2" defaultChecked={idx === 0} />
                                            <div className="collapse-title text-lg font-semibold text-gray-800 min-h-fit py-4 flex items-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                </svg>
                                                Tahun {data?.year}
                                            </div>
                                            <div className="collapse-content bg-white px-2 sm:px-4">
                                                <div className="overflow-x-auto -mx-2 sm:mx-0">
                                                    <table className="table table-zebra w-full">
                                                        <thead className="bg-gray-100">
                                                            <tr>
                                                                <th className="text-gray-700 font-semibold">Periode</th>
                                                                <th className="text-gray-700 font-semibold">Total</th>
                                                                <th className="text-gray-700 font-semibold">Status</th>
                                                                <th className="text-gray-700 font-semibold text-center">Aksi</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                data?.details?.map((d, idx) => (
                                                                    <tr key={idx} className="hover:bg-gray-50">
                                                                        <td className="font-medium text-gray-900">{`${d?.month} ${data?.year}`}</td>
                                                                        <td className="font-semibold text-gray-900">Rp. {numeral(d?.total_tagihan).format('0,0')}</td>
                                                                        <td>
                                                                            {d.status == 'LUNAS' && 
                                                                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800">
                                                                                    <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                                                    </svg>
                                                                                    {d.status}
                                                                                </span>
                                                                            }
                                                                            {d.status == 'BELUM LUNAS' && 
                                                                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-800">
                                                                                    <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                                                                    </svg>
                                                                                    {d.status}
                                                                                </span>
                                                                            }
                                                                            {(d.status != 'BELUM LUNAS' && d.status != 'LUNAS') && 
                                                                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-800">
                                                                                    {d.status}
                                                                                </span>
                                                                            }
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <Link
                                                                                to={`/info-tagihan/${d?.id}?history=${pelanggan?.kode_pelanggan}&last_page=${page}`}
                                                                                className="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-xs font-medium rounded-lg hover:bg-blue-700 transition-colors shadow-sm"
                                                                            >
                                                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                                                </svg>
                                                                                Detail
                                                                            </Link>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                )
            }

            {/* show loading */}
            {
                (isLoading) &&
                (
                    <div className="w-full max-w-5xl mx-auto">
                        <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
                            <div className="flex flex-col gap-4">
                                <div className="flex items-center justify-center py-8">
                                    <svg className="animate-spin h-10 w-10 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                </div>
                                <div className="skeleton h-4 w-full"></div>
                                <div className="skeleton h-4 w-10/12 mx-auto"></div>
                                <div className="skeleton h-4 w-9/12 mx-auto"></div>
                            </div>
                        </div>
                    </div>
                )
            }

            {/* show paging */}
            {
                (!firstInit && !isError && totalPage > 1) &&
                (
                    <nav aria-label="Page navigation" className="flex justify-center my-6">
                        <div className="bg-white rounded-lg shadow-md border border-gray-200 p-2">
                            <ul className="inline-flex space-x-1" style={{ listStyle: 'none' }}>
                                <li>
                                    <button 
                                        className={`px-3 py-2 rounded-md font-medium transition-colors ${page > 1 ? 'text-blue-600 hover:bg-blue-50' : 'text-gray-400 cursor-not-allowed'}`}
                                        aria-label="Previous" 
                                        disabled={page <= 1}
                                        onClick={() => {
                                            let _page = page;
                                            if (_page > 1) {
                                                _page -= 1;
                                                setPage(_page);
                                                getData(_page);
                                            }
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                        </svg>
                                    </button>
                                </li>
                                {Array.from({ length: totalPage }, (_, index) => index + 1).map((n) => (
                                    <li key={n}>
                                        <button
                                            className={`px-4 py-2 rounded-md font-medium transition-colors ${parseInt(page) === parseInt(n) ? 'bg-blue-600 text-white shadow-md' : 'text-gray-700 hover:bg-gray-100'}`}
                                            onClick={() => {
                                                setPage(n);
                                                getData(n);
                                            }}
                                        >{n}</button>
                                    </li>
                                ))}
                                <li>
                                    <button 
                                        className={`px-3 py-2 rounded-md font-medium transition-colors ${page < totalPage ? 'text-blue-600 hover:bg-blue-50' : 'text-gray-400 cursor-not-allowed'}`}
                                        aria-label="Next" 
                                        disabled={page >= totalPage}
                                        onClick={() => {
                                            let _page = page;
                                            if (_page < totalPage) {
                                                _page += 1;
                                                setPage(_page);
                                                getData(_page);
                                            }
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                        </svg>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </nav>
                )
            }

            {/* Error Message */}
            {
                (isError && !isLoading) &&
                (
                    <div className="w-full max-w-5xl mx-auto">
                        <div className="bg-red-50 border-l-4 border-red-500 rounded-lg p-6 shadow-md">
                            <div className="flex items-center">
                                <div className="flex-shrink-0">
                                    <svg className="h-8 w-8 text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                    </svg>
                                </div>
                                <div className="ml-4">
                                    <h3 className="text-lg font-semibold text-red-800 mb-1">Data Tidak Ditemukan</h3>
                                    <p className="text-red-700">Data pelanggan dengan nomor sambung tersebut tidak ditemukan. Pastikan nomor sambung yang Anda masukkan sudah benar.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </Content>
    )
}

export default Tagihan